import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type LegalModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
};
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-193">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-50 flex items-start justify-center bg-black/70 backdrop-blur-sm p-4 overflow-y-auto" onClick={onClose} data-id="element-194">
          <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 40
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="bg-navy-900 border border-white/10 rounded-2xl max-w-2xl w-full my-12 relative" onClick={e => e.stopPropagation()} data-id="element-195">
            <div className="sticky top-0 bg-navy-900 border-b border-white/10 rounded-t-2xl px-8 py-5 flex items-center justify-between z-10" data-id="element-196">
              <h2 className="font-playfair text-xl font-bold text-offwhite" data-id="element-197">
                {title}
              </h2>
              <button onClick={onClose} className="w-9 h-9 rounded-full bg-white/5 hover:bg-white/10 flex items-center justify-center transition-colors" aria-label="Cerrar" data-id="element-198">
                <XIcon className="w-5 h-5 text-offwhite/70" data-id="element-199" />
              </button>
            </div>
            <div className="px-8 py-8 text-offwhite/70 text-sm leading-relaxed space-y-4" data-id="element-200">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}